import { ComponentProps } from 'react'
import { cn } from '~utils/cn'

import { TextInputLabelProps } from './label'

type TextInputStateProps = Pick<TextInputLabelProps, 'isError' | 'isDisabled'>
type HelperProps = ComponentProps<'div'> & {
  showMaxLength: boolean
  maxLength: number
  valueLength: number
  readOnly: boolean
  helperMessage?: string
}

export type TextInputHelperProps = Readonly<TextInputStateProps & Partial<HelperProps>>

const TextInputHelper = ({
  helperMessage,
  showMaxLength,
  maxLength,
  valueLength,
  isError,
  isDisabled,
  className,
}: TextInputHelperProps) => {
  const render = !!helperMessage?.length || (!!maxLength && showMaxLength)

  if (!render) {
    return <></>
  }

  return (
    <div
      className={cn(
        'flex items-center justify-between',
        !helperMessage && 'justify-end',
        className
      )}
    >
      {helperMessage && (
        <div
          className={cn('text-gray-500 text-body-3', {
            'text-red-500': isError,
            'text-gray-300': isDisabled,
          })}
        >
          {helperMessage}
        </div>
      )}
      {maxLength && showMaxLength && (
        <div
          className={cn('text-gray-500 text-body-2', {
            'text-gray-300': isDisabled,
          })}
        >{`${valueLength || 0}/${maxLength}`}</div>
      )}
    </div>
  )
}

export default TextInputHelper
